/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ProtectedImport } from './routes/_protected'
import { Route as AuthImport } from './routes/_auth'
import { Route as ProtectedIndexImport } from './routes/_protected/index'
import { Route as InviteEventSlugImport } from './routes/invite.$eventSlug'
import { Route as ProtectedOnboardingImport } from './routes/_protected/onboarding'
import { Route as AuthVerifyImport } from './routes/_auth/verify'
import { Route as AuthLoginImport } from './routes/_auth/login'
import { Route as ProtectedUProfileImport } from './routes/_protected/u/$profile'
import { Route as ProtectedEventCreateImport } from './routes/_protected/event/create'
import { Route as ProtectedEventEventSlugImport } from './routes/_protected/event/$eventSlug'
import { Route as ProtectedEventEventSlugEditImport } from './routes/_protected/event/$eventSlug_.edit'

// Create/Update Routes

const ProtectedRoute = ProtectedImport.update({
  id: '/_protected',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedIndexRoute = ProtectedIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedRoute,
} as any)

const InviteEventSlugRoute = InviteEventSlugImport.update({
  id: '/invite/$eventSlug',
  path: '/invite/$eventSlug',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedOnboardingRoute = ProtectedOnboardingImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => ProtectedRoute,
} as any)

const AuthVerifyRoute = AuthVerifyImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => AuthRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)

const ProtectedUProfileRoute = ProtectedUProfileImport.update({
  id: '/u/$profile',
  path: '/u/$profile',
  getParentRoute: () => ProtectedRoute,
} as any)

const ProtectedEventCreateRoute = ProtectedEventCreateImport.update({
  id: '/event/create',
  path: '/event/create',
  getParentRoute: () => ProtectedRoute,
} as any)

const ProtectedEventEventSlugRoute = ProtectedEventEventSlugImport.update({
  id: '/event/$eventSlug',
  path: '/event/$eventSlug',
  getParentRoute: () => ProtectedRoute,
} as any)

const ProtectedEventEventSlugEditRoute =
  ProtectedEventEventSlugEditImport.update({
    id: '/event/$eventSlug_/edit',
    path: '/event/$eventSlug/edit',
    getParentRoute: () => ProtectedRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedImport
      parentRoute: typeof rootRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof AuthImport
    }
    '/_auth/verify': {
      id: '/_auth/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof AuthVerifyImport
      parentRoute: typeof AuthImport
    }
    '/_protected/onboarding': {
      id: '/_protected/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof ProtectedOnboardingImport
      parentRoute: typeof ProtectedImport
    }
    '/invite/$eventSlug': {
      id: '/invite/$eventSlug'
      path: '/invite/$eventSlug'
      fullPath: '/invite/$eventSlug'
      preLoaderRoute: typeof InviteEventSlugImport
      parentRoute: typeof rootRoute
    }
    '/_protected/': {
      id: '/_protected/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ProtectedIndexImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/event/$eventSlug': {
      id: '/_protected/event/$eventSlug'
      path: '/event/$eventSlug'
      fullPath: '/event/$eventSlug'
      preLoaderRoute: typeof ProtectedEventEventSlugImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/event/create': {
      id: '/_protected/event/create'
      path: '/event/create'
      fullPath: '/event/create'
      preLoaderRoute: typeof ProtectedEventCreateImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/u/$profile': {
      id: '/_protected/u/$profile'
      path: '/u/$profile'
      fullPath: '/u/$profile'
      preLoaderRoute: typeof ProtectedUProfileImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/event/$eventSlug_/edit': {
      id: '/_protected/event/$eventSlug_/edit'
      path: '/event/$eventSlug/edit'
      fullPath: '/event/$eventSlug/edit'
      preLoaderRoute: typeof ProtectedEventEventSlugEditImport
      parentRoute: typeof ProtectedImport
    }
  }
}

// Create and export the route tree

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthVerifyRoute: AuthVerifyRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface ProtectedRouteChildren {
  ProtectedOnboardingRoute: typeof ProtectedOnboardingRoute
  ProtectedIndexRoute: typeof ProtectedIndexRoute
  ProtectedEventEventSlugRoute: typeof ProtectedEventEventSlugRoute
  ProtectedEventCreateRoute: typeof ProtectedEventCreateRoute
  ProtectedUProfileRoute: typeof ProtectedUProfileRoute
  ProtectedEventEventSlugEditRoute: typeof ProtectedEventEventSlugEditRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedOnboardingRoute: ProtectedOnboardingRoute,
  ProtectedIndexRoute: ProtectedIndexRoute,
  ProtectedEventEventSlugRoute: ProtectedEventEventSlugRoute,
  ProtectedEventCreateRoute: ProtectedEventCreateRoute,
  ProtectedUProfileRoute: ProtectedUProfileRoute,
  ProtectedEventEventSlugEditRoute: ProtectedEventEventSlugEditRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof ProtectedRouteWithChildren
  '/login': typeof AuthLoginRoute
  '/verify': typeof AuthVerifyRoute
  '/onboarding': typeof ProtectedOnboardingRoute
  '/invite/$eventSlug': typeof InviteEventSlugRoute
  '/': typeof ProtectedIndexRoute
  '/event/$eventSlug': typeof ProtectedEventEventSlugRoute
  '/event/create': typeof ProtectedEventCreateRoute
  '/u/$profile': typeof ProtectedUProfileRoute
  '/event/$eventSlug/edit': typeof ProtectedEventEventSlugEditRoute
}

export interface FileRoutesByTo {
  '': typeof AuthRouteWithChildren
  '/login': typeof AuthLoginRoute
  '/verify': typeof AuthVerifyRoute
  '/onboarding': typeof ProtectedOnboardingRoute
  '/invite/$eventSlug': typeof InviteEventSlugRoute
  '/': typeof ProtectedIndexRoute
  '/event/$eventSlug': typeof ProtectedEventEventSlugRoute
  '/event/create': typeof ProtectedEventCreateRoute
  '/u/$profile': typeof ProtectedUProfileRoute
  '/event/$eventSlug/edit': typeof ProtectedEventEventSlugEditRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_protected': typeof ProtectedRouteWithChildren
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/verify': typeof AuthVerifyRoute
  '/_protected/onboarding': typeof ProtectedOnboardingRoute
  '/invite/$eventSlug': typeof InviteEventSlugRoute
  '/_protected/': typeof ProtectedIndexRoute
  '/_protected/event/$eventSlug': typeof ProtectedEventEventSlugRoute
  '/_protected/event/create': typeof ProtectedEventCreateRoute
  '/_protected/u/$profile': typeof ProtectedUProfileRoute
  '/_protected/event/$eventSlug_/edit': typeof ProtectedEventEventSlugEditRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/login'
    | '/verify'
    | '/onboarding'
    | '/invite/$eventSlug'
    | '/'
    | '/event/$eventSlug'
    | '/event/create'
    | '/u/$profile'
    | '/event/$eventSlug/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/login'
    | '/verify'
    | '/onboarding'
    | '/invite/$eventSlug'
    | '/'
    | '/event/$eventSlug'
    | '/event/create'
    | '/u/$profile'
    | '/event/$eventSlug/edit'
  id:
    | '__root__'
    | '/_auth'
    | '/_protected'
    | '/_auth/login'
    | '/_auth/verify'
    | '/_protected/onboarding'
    | '/invite/$eventSlug'
    | '/_protected/'
    | '/_protected/event/$eventSlug'
    | '/_protected/event/create'
    | '/_protected/u/$profile'
    | '/_protected/event/$eventSlug_/edit'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  ProtectedRoute: typeof ProtectedRouteWithChildren
  InviteEventSlugRoute: typeof InviteEventSlugRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  ProtectedRoute: ProtectedRouteWithChildren,
  InviteEventSlugRoute: InviteEventSlugRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_auth",
        "/_protected",
        "/invite/$eventSlug"
      ]
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/login",
        "/_auth/verify"
      ]
    },
    "/_protected": {
      "filePath": "_protected.tsx",
      "children": [
        "/_protected/onboarding",
        "/_protected/",
        "/_protected/event/$eventSlug",
        "/_protected/event/create",
        "/_protected/u/$profile",
        "/_protected/event/$eventSlug_/edit"
      ]
    },
    "/_auth/login": {
      "filePath": "_auth/login.tsx",
      "parent": "/_auth"
    },
    "/_auth/verify": {
      "filePath": "_auth/verify.tsx",
      "parent": "/_auth"
    },
    "/_protected/onboarding": {
      "filePath": "_protected/onboarding.tsx",
      "parent": "/_protected"
    },
    "/invite/$eventSlug": {
      "filePath": "invite.$eventSlug.tsx"
    },
    "/_protected/": {
      "filePath": "_protected/index.tsx",
      "parent": "/_protected"
    },
    "/_protected/event/$eventSlug": {
      "filePath": "_protected/event/$eventSlug.tsx",
      "parent": "/_protected"
    },
    "/_protected/event/create": {
      "filePath": "_protected/event/create.tsx",
      "parent": "/_protected"
    },
    "/_protected/u/$profile": {
      "filePath": "_protected/u/$profile.tsx",
      "parent": "/_protected"
    },
    "/_protected/event/$eventSlug_/edit": {
      "filePath": "_protected/event/$eventSlug_.edit.tsx",
      "parent": "/_protected"
    }
  }
}
ROUTE_MANIFEST_END */
